import { Button } from '@mui/material';
import { OpenNewTabIcon } from 'apps/app/src/components/icons/OpenNewTabIcon';
import { useTabSelection } from 'apps/app/src/hooks/use-tab-selection';
import type { ReportType } from '../../../reports-page-types/report-type';

export const NavigateToReportTypeButton: React.FC<{ type: ReportType }> = ({ type }) => {
  const { handleTabSelection } = useTabSelection();
  
  return (
    <Button
      variant='outlined'
      color='primary'
      size='small'
      onClick={()=> handleTabSelection(type)}
      endIcon={
        <OpenNewTabIcon
          width={17}
          height={17}
        />}
    >
      Open
    </Button>
  );
};